import React from 'react';
import style from './MainHome.module.scss'
import LeftSide from '../../compents/leftSide/LeftSide.js'
import RightSide from '../../compents/rightSide/RightSide.js'
import HomeSrc from '../../image/icon/icon_index.png'
import InfoSrc from '../../image/icon/icon_info.png'
import Logo from '../../image/icon/index_logo.png'
import ContactSrc from '../../image/icon/icon_contact.png'
import {Link} from 'react-router-dom'
import arrow from '../../image/icon/arrow.png'
import PageCenter_logo from '../../image/temp/eyemove_logo.png'
import $ from 'jquery'


class MainHome extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data:null,
      leftState:                false,
      rightState:               false,
      nowCase:                  [],
      caseState:                false,
      pageState:                1,
      background_Arr:[],
      background_MobileArr:[],
      background_Now:0,
      background_MobileNow:0,
      pageTitle_Now:0,
      pageTitle_ch:[],
      isMobile:false
    };
  }
    componentDidMount() {
        var that = this;
        $.ajax({
            type:'get',
            url:'/home/home.json',
            success:function (data) {
                that.setState({
                    data:data,
                    background_Arr:data.background_Arr,
                    background_MobileArr:data.background_MobileArr,
                    pageTitle_ch:data.pageTitle_ch
                })
            }
        })


        //设置轮播
        setInterval(()=>{
            this.indexChange();
        },5000)
        window.addEventListener("resize",this.indexChange.bind(this));
        this.indexChange();
    }
    componentWillUnmount() {
        // window.removeEventListener('resize',this.indexChange)
    }
    indexChange(){
      this.setState({isMobile:window.innerWidth<=760})
      if(!this.state.isMobile){
          if(this.state.background_Now ==this.state.background_Arr.length-1){
              this.setState({
                  background_Now:0
              })

          }else{
              this.setState({
                  background_Now:this.state.background_Now+1
              })
          }
      }else{

          if(this.state.background_MobileNow==this.state.background_MobileArr.length-1){
              this.setState({
                  background_MobileNow:0
              })
          }else {
              this.setState({
                  background_MobileNow:this.state.background_MobileNow+1,
              })
          }
      }
      if(this.state.pageTitle_Now==this.state.pageTitle_ch.length-1){
          this.setState({
              pageTitle_Now:0
          })
      }else{
          this.setState({
              pageTitle_Now:this.state.pageTitle_Now+1
          })
      }
      console.log("pageTitle_now"+this.state.pageTitle_Now)
    }
    ImageChange=(imgIndex2)=>{
        if(this.state.background_MobileNow==this.state.background_MobileArr.length-1){
            this.setState({
                background_MobileNow:0
            })
        }else {
            this.setState({
                background_MobileNow:imgIndex2,
            })
        }
        if(this.state.pageTitle_Now==this.state.pageTitle_ch.length-1){
            this.setState({
                pageTitle_Now:0
            })
        }else{
            this.setState({
                pageTitle_Now:imgIndex2+1
            })
        }
    }
    PCImageChange=(imgIndex3)=>{
      if (this.state.background_Now==this.state.background_Arr.length-1){
          this.setState({
              background_Now:0
          })
      }else{
          this.setState({
              background_Now:imgIndex3
          })
      }
      if (this.state.pageTitle_Now==this.state.pageTitle_ch.length-1){
          this.setState({
              pageTitle_Now:0
          })
      }else {
          this.setState({
              pageTitle_Now:imgIndex3+1
          })
      }
    }
    getDetail=(index)=>{
       switch (index) {
           case 0:
               // alert("跳转3")
               break
           case 1:
               // alert("跳转1")
               break
           case 2:
               var anchorElement = document.getElementById("caselist");
               if(anchorElement){
                   anchorElement.scrollIntoView(true,{behavior: "smooth" })
               }
               this.setState({
                   pageState:2
               })
               break
       }
    }
    openLeftSide=()=>{
        this.setState({
            leftState:!this.state.leftState
        })
    }
    openRightSide=()=>{
        this.setState({
            rightState:!this.state.rightState
        })
    }
    closeSide=()=>{
        if (this.state.leftState){
            this.setState({
                leftState:false,
            })
        }
        if(this.state.rightState){
            this.setState({
                rightState:false,
            })
        }

    }
    disabledMouseWheel=()=> {

    }
    //跳到指定位置
    scrollToAnchor = (pageNum) => {
      switch (pageNum) {
          case 1:
              var anchorElement = document.getElementById("caselist");
              if(anchorElement){
                  anchorElement.scrollIntoView(true,{behavior: "smooth" })
              }
              this.setState({
                  pageState:2
              })
              break
          case 2:
              var anchorElement = document.getElementById("index");
              if(anchorElement){
                  anchorElement.scrollIntoView(true,{behavior: "smooth" })
              }
              this.setState({
                  pageState:1,
              })
              break
          case 3:
              var anchorElement = document.getElementById("caselist");
              if(anchorElement){
                  anchorElement.scrollIntoView(true,{behavior: "smooth" })
              }
              this.setState({
                  pageState:2,
                  caseState:false,
              })
              break
      }

  }
    getCase=(index)=>{
    this.setState({
        caseState:true,
        pageState:3
    })
    var data= this.state.data.caselist[index].content;
    this.setState({
        nowCase:this.state.data.caselist[index]
    })
  }
    render() {
          let {background_MobileNow,background_MobileArr} = this.state;
          let {background_Now,background_Arr} = this.state;
          let imgList1=background_MobileArr.map((item,imgIndex)=>{
              return  <div key={imgIndex} className={style.background} style={{'display':background_MobileNow == imgIndex ? 'block' : 'none',backgroundImage:'url('+item+')'}} id={"animat"}>
                  {imgIndex==1?<div className={style.mengban}>
                      <div className={style.p_item1} onClick={()=>{window.location.href='Product/3'}}/>
                      <div className={style.p_item2} onClick={()=>{window.location.href='Product/1'}}/>
                      <div className={style.p_item3} onClick={()=>{window.location.href='Product/6'}}/>
                      <div className={style.p_item4} onClick={()=>{window.location.href='Product/7'}}/>
                      <div className={style.p_item5} onClick={()=>{window.location.href='Product/2'}}/>
                      <div className={style.p_item6} onClick={()=>{window.location.href='Product/4'}}/>
                      <div className={style.p_item7} onClick={()=>{window.location.href='Product/5'}}/>
                      <div className={style.p_item8} onClick={()=>{window.location.href='Product/8'}}/>
                  </div>:""}
              </div>
          })
          let imgList2=background_Arr.map((item,imgIndex)=>{
              return  <div key={imgIndex} className={style.background} style={{'display':background_Now == imgIndex ? 'block' : 'none',backgroundImage:'url('+item+')'}} id={"animat"}/>
          })
          let liList = background_MobileArr.map((item2,imgIndex2)=>{
              return <div className={style.single_Index} key={imgIndex2} style={{'backgroundColor':background_MobileNow == imgIndex2?'#d75420':'#fff'}} onClick={(e)=>this.ImageChange(imgIndex2)}></div>
          })
          let liList2 = background_Arr.map((item3,imgIndex3)=>{
              return <div className={style.single_Index} key={imgIndex3} style={{'backgroundColor':background_Now==imgIndex3?'#d75420':'#fff'}} onClick={(e)=>this.PCImageChange(imgIndex3)}></div>
          })
    return (
        this.state.data!==null?<div className={style.mainhome}>
          <div className={style.view} id={"index"} >
              {this.state.isMobile?imgList1:imgList2}
              <div className={style.img_Index}>
                  {this.state.isMobile?liList:liList2}
              </div>
              {
                  this.state.data.pageTitle_ch.map((item,index)=>{
                      if(this.state.isMobile){
                          return <div className={style.page_center} key={index} style={{'display':this.state.pageTitle_Now == index ? 'block' : 'none'}}>
                              <h2 className={style.pageTtile} style={{'color':index==2?'#646262':'#fff','marginTop':index==2?'8rem':''}}>{item}</h2>
                              <p  style={{'color':index==2?'#646262':'#fff'}} onClick={(e)=>this.getDetail(index)}>了解更多信息</p>
                          </div>
                      }else{
                          return <div className={style.page_center} key={index} style={{'display':this.state.pageTitle_Now == index ? 'block' : 'none'}}>
                              <h2 className={style.pageTtile}>{item}</h2>
                              <p onClick={(e)=>this.getDetail(index)}>了解更多信息</p>
                          </div>
                      }

                  })
              }

          </div>
          <div className={style.case} id={"caselist"}>
              {
                  this.state.data.caselist.map((item,index)=>{
                      if (this.state.isMobile){
                          return  <Link to={`Product/${item.id}`} key={index}>
                              <div className={style.case_bg} style={{backgroundImage:'url('+item.imgsrc+')'}}>
                                  <div className={style.hover_view}>
                                    <h2>{item.content}</h2>
                                    <p>{item.content_en}</p>
                                  </div>
                              </div>
                          </Link>
                      }else{
                          return <Link to={`Product/${item.id}`} key={index}>
                              <div className={style.case_bg} style={{backgroundImage:'url('+item.imgsrc+')'}}>
                                  <div className={style.hover_view}>
                                      <h2>{item.content}</h2>
                                      <div className={style.line}></div>
                                      <p>{item.text}</p>
                                  </div>
                              </div>
                          </Link>
                      }
                  })
              }
          </div>
          <img className={style.home_logo} src={Logo} title="LOGO" onClick={(e)=>this.scrollToAnchor(this.state.pageState)}/>
          <img className={style.btn_main} src={this.state.isMobile?PageCenter_logo:HomeSrc} title="首页" onClick={(e)=>this.scrollToAnchor(this.state.pageState)}/>
          <img className={style.btn_info} src={InfoSrc} title="关于我们" onClick={(e)=>this.openLeftSide(e)}/>
          <img className={style.btn_contact} src={ContactSrc} title="联系我们" onClick={(e)=>this.openRightSide(e)}/>
          <img className={style.btn_arrow} src={arrow} title="查看更多" onClick={(e)=>this.scrollToAnchor(this.state.pageState)} style={{'display':this.state.pageState==1?'block':'none'}}/>
          <LeftSide leftState={this.state.leftState} close={(e)=>this.openLeftSide(e)}></LeftSide>
          <RightSide rightState={this.state.rightState} close={(e)=>this.openRightSide(e)}></RightSide>
      </div>:""

    );
  }

}


export default MainHome;
